import { BoardroomHire } from "../components/BoardroomHire";

export default function BoardroomsPage() {
  return (
    <main data-testid="boardrooms-page" className="animate-in fade-in duration-500">
      <section className="max-w-7xl mx-auto px-6 sm:px-12 pt-16 sm:pt-24 pb-12 sm:pb-16">
        <p className="font-sans text-xs tracking-[0.35em] uppercase text-[#8B7355] mb-6">Service 01 · Toowoomba & Sunshine Coast</p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight text-[#2D231E] leading-[1.02] mb-6">
          Boardroom <span className="italic text-[#8B7355]">Hire</span>
        </h1>
        <p className="font-serif text-xl sm:text-2xl italic text-[#4A3C31] max-w-2xl mb-4">
          Three boardrooms — choose the room that fits your meeting.
        </p>
        <p className="font-sans text-base text-[#5D4037] max-w-2xl">
          Each request goes straight to our team — we'll confirm availability in
          your inbox shortly after.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 sm:px-12 pb-24 sm:pb-32 space-y-14 lg:space-y-20">
        <BoardroomHire locationKey="toowoomba" locationLabel="Saba Workspace · Toowoomba" />
        <BoardroomHire locationKey="buderim" locationLabel="Buderim Workspace · Sunshine Coast" />
      </section>
    </main>
  );
}
